import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useClinicalAccount } from "../../clinical-context";
import { ClinicalAnalyticFilters } from "./filters";
import { AnalyticsProvider } from "./context";
import { TotalScoreGraph } from "./total-score-graph";
import { QuestionGraphs } from "./question-graphs";

export const QuestionnaireAnalytics = () => {
  const { isClinician } = useClinicalAccount();
  const navigate = useNavigate();

  useEffect(() => {
    if (isClinician === null) return;

    if (!isClinician) {
      navigate("/account/login/clinical");
    }
  }, [isClinician]);

  if (!isClinician) return <></>;

  return (
    <AnalyticsProvider>
      <main className="analytics">
        <div className="main">
        <h1>Dashboard</h1>
          <div style={{borderBottom: "none"}}>
            <ClinicalAnalyticFilters />
            <div style={{width: "100%"}}>
                <TotalScoreGraph />
            </div>
          </div>
             <QuestionGraphs />
        </div>
      </main>
    </AnalyticsProvider>
  );
};
